export default __webpack_public_path__ + "static/media/151-plumbering-1.8fc03e06.png";